module.exports = __webpack_public_path__ + "static/media/transportation-tag-icon.8b2e26f7.svg";